import React from 'react';
import TextLink from '../../core/TextLink';
import ErrorPage from '../ErrorPage';
import Layout, { withLayout } from '../Layout';
import LogData from '../../../helpers/LogData';
import Redirect from '../../../helpers/Redirect';
import LayoutActions from '../../../flux/actions/LayoutActions';
import LayoutStore from '../../../flux/stores/LayoutStore';
class SpecifcError extends React.Component {
    constructor(props) {
        super(props);
        this.hideAllLoaders = () => {
            this.setState({
                isLoading: false
            });
        };
        this.resolveLayoutReady = () => {
            try {
                const { resources } = this.state;
                if (resources) {
                    document.title = resources.lblPageTitle;
                    this.setState({
                        isAuthenticated: LayoutStore.getIsAuthenticated(),
                        isLoading: false
                    }, LayoutActions.hidePageLoader);
                }
                else {
                    this.logError(LogData.noResources(this.resolveLayoutReady.name));
                }
            }
            catch (e) {
                this.logError(LogData.fromException(this.resolveLayoutReady.name, e));
            }
        };
        this.onLayoutReady = () => {
            const ready = LayoutStore.getLayoutReady();
            const resources = LayoutStore.getResources();
            if (ready) {
                this.setState({
                    resources: resources
                }, this.resolveLayoutReady);
            }
            else {
                this.logError(LogData.layoutNoReady(this.onLayoutReady.name));
                this.redirectError(500);
            }
        };
        this.idModule = 'Errors';
        const hdnIdPage = document.getElementById('hdnIdPage');
        if (hdnIdPage && hdnIdPage.value) {
            this.idPage = hdnIdPage.value;
            hdnIdPage.remove();
        }
        else {
            this.idPage = '';
            Redirect.toError();
        }
        this.state = this.getInitialState();
        LayoutStore.addLayoutReadyListener(this.onLayoutReady);
    }
    getInitialState() {
        let isLoading = true;
        let resources;
        if (this.state) {
            isLoading = this.state.isLoading;
            resources = this.state.resources;
        }
        return {
            isAuthenticated: false,
            isLoading: isLoading,
            resources: resources
        };
    }
    redirectToHome() {
        Redirect.toHome();
    }
    logError(logData) {
        this.hideAllLoaders();
        LayoutActions.setLogData(logData);
    }
    redirectError(code) {
        this.hideAllLoaders();
        LayoutActions.setRedirectCode(code);
    }
    componentWillUnmount() {
        LayoutStore.removeLayoutReadyListener(this.onLayoutReady);
    }
    render() {
        const { homeButtonRequireAuth } = this.props;
        const { isAuthenticated, isLoading, resources } = this.state;
        let contentPage;
        if (resources && !isLoading) {
            let errorCode = '500';
            switch (this.idPage) {
                case 'Error400':
                    errorCode = '400';
                    break;
                case 'Error401':
                    errorCode = '401';
                    break;
                case 'Error403':
                case 'ExpiredInvitation':
                case 'InvalidInvitation':
                case 'InvalidToken':
                    errorCode = '403';
                    break;
                case 'Error404':
                    errorCode = '404';
                    break;
                case 'Error500':
                    errorCode = '500';
                    break;
                case 'Error503':
                    errorCode = '503';
                    break;
            }
            const hasAction = !homeButtonRequireAuth || (homeButtonRequireAuth && (this.idPage !== 'Error401' || isAuthenticated));
            contentPage = (React.createElement(ErrorPage, { action: hasAction ? (React.createElement(TextLink, { href: "#", id: "btnGoHome", onClick: this.redirectToHome }, resources.lblGoToHome)) : null, errorTitle: resources.lblTitle, errorType: errorCode, hasAction: hasAction, id: "ErrorPage", message: resources.lblText, noHeader: true }));
        }
        return (React.createElement(Layout, { idModule: this.idModule, idPage: this.idPage, noPadding: true }, contentPage));
    }
}
const SpecifcErrorWithLayout = withLayout(SpecifcError);
export default SpecifcErrorWithLayout;
